import { ApiError } from '@core/api/apiError';
import type { DeleteDataResult } from '@core/api/consent';
import { pointsWord } from '@core/utils/redemptionCancel';

// Удаление своих данных (K-025, 152-ФЗ ст. 21). Чистые функции экрана «Мои данные» и флаг «данные удалены»:
// после удаления вход больше не должен молча заводить новую карточку (мини-апп на 401 входит заново по initData —
// это и была бы «повторная регистрация» без ведома клиента). Новая карточка — только при следующем открытии.

let erased = false;
const ERASED_KEY = 'lunit:data-erased';

/** Данные удалены в этой сессии приложения: повторный вход на 401 не выполняется. */
export function markDataErased(): void {
  erased = true;
  try {
    sessionStorage.setItem(ERASED_KEY, '1');
  } catch {
    // приватный режим — достаточно флага в памяти
  }
}

export function isDataErased(): boolean {
  if (erased) return true;
  try {
    return sessionStorage.getItem(ERASED_KEY) === '1';
  } catch {
    return false;
  }
}

/** Что увидит клиент после удаления. */
export function erasureDoneText(r: DeleteDataResult): string {
  const parts = ['Ваши данные удалены, согласия отозваны.'];
  if (r.balanceZeroed > 0) {
    parts.push(`Списано ${r.balanceZeroed} ${pointsWord(r.balanceZeroed)}.`);
  }
  parts.push(
    r.welcomeBlocked
      ? 'Если вы зарегистрируетесь снова, это будет новая карточка без приветственного бонуса: вы уже пользовались баллами.'
      : 'Если вы зарегистрируетесь снова, это будет новая карточка.'
  );
  return parts.join(' ');
}

/** Текст ошибки удаления (тост на экране). */
export function erasureErrorText(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code === 'POS_ORDER_IN_PROGRESS') {
      return 'Награда уже передана на кассу. Дождитесь выдачи или отказа кассы и повторите удаление.';
    }
    if (err.status === 401) {
      return 'Сессия истекла. Откройте приложение заново и повторите.';
    }
    if (err.status === 503) {
      return 'Удаление данных временно недоступно. Попробуйте позже или напишите заведению.';
    }
  }
  return 'Не удалось удалить данные. Попробуйте ещё раз.';
}
